<template>
    <Modal v-on="$listeners">
        <SectionTitle
            :title="config.INFORMATION_TITLE"
            :description="config.INFORMATION_DESCRIPTION"
        />
        <SectionPicture>
            <ArtPuzzle :color="config.COLOR_PRIMARY"/>
        </SectionPicture>
        <section class="form">
            <form id="form" @submit.prevent="onSubmit">
                <Input
                    v-model="url"
                    type="url"
                    :label="config.INFORMATION_PRODUCT_URL"
                    :placeholder="config.INFORMATION_PRODUCT_URL_PLACEHOLDER || config.INFORMATION_PRODUCT_URL"
                />
                <Input
                    v-model="title"
                    type="text"
                    :label="config.INFORMATION_PRODUCT_TITLE"
                    :placeholder="config.INFORMATION_PRODUCT_TITLE_PLACEHOLDER || config.INFORMATION_PRODUCT_TITLE"
                />
            </form>
        </section>
        <SectionActions>
            <Button type="submit" form="form" :color="config.COLOR_PRIMARY">
                {{ config.INFORMATION_CTA }}
            </Button>
        </SectionActions>
    </Modal>
</template>
<script>
import { SolutionConsumer, ProjectConsumer } from '../../mixins';
import {
    SectionPicture, SectionTitle, SectionActions,
} from '../../components/shared';

export default {
    name: 'ModalInformation',
    components: {
        SectionPicture, SectionTitle, SectionActions,
    },
    mixins: [SolutionConsumer, ProjectConsumer],
    data () {
        return {
            title: '',
            url: '',
        };
    },
    created () {
        this.title = this.uploadInformation.productTitle || '';
        this.url = this.uploadInformation.productUrl || '';
    },
    methods: {
        async onSubmit () {
            await this.addUploadInformation({
                productTitle: this.title,
                productUrl: this.url,
            });
            this.$emit('done');
        },
    },
};
</script>
